module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-6@3x.8b8c888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-6@3x.png
// module id = 2geS
// module chunks = 18